module.exports = __webpack_public_path__ + "static/media/comment.853b82c2.svg";